<template>
  <section class="sme-container ">
    <div class="flex-sb-center mg-b-30">
      <h1>Create Refer Case Ticket</h1>
      <template>
        <div >
          <v-button @click="$router.back()">Back</v-button>
          <v-button
            type="primary"
            @click="handleNext"
          >Next</v-button>
        </div>
      </template>
    </div>
    <info
      :formData="smeQuickForm"
      :sme-class-id="sme_class_id"></info>
    <send-email-sms
      ref="send-form"
      :form="customerData"
      :initContent="initContent"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      :updateContent="true"
      @send="handlerEmailSmsSend"
      @skip="handlerEmailSmsSkip" ></send-email-sms>
  </section>
</template>

<script>
import info from './sme/component/smeQucikInfo'
import sendEmailSms from '@/views/components/dialogs/send-email-sms'
import MixinOptions from '@/mixins/options'
import MixinSMERefer from '@/mixins/smeRefer'
import MinxinFormat from '@/mixins/format'

export default {
  name: 'smeRefer',
  components:{
    info,
    sendEmailSms
  },
  mixins: [MixinOptions,MixinSMERefer,MinxinFormat],
  data(){
    return{
    }
  },
  computed:{
  },
  methods:{
    handleNext(){
      if(this.customerId){
        this.getAccountDetail()
      }else  this.$router.push('/quoting/customer/refer')
    }
  }
}
</script>

<style scoped lang="scss">
  .sme-container{
    .mg-b-30{
      margin-bottom: 30px;
    }
    h1{
      font-family: 'SF Pro Display';
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 36px;
      color: $dark;
    }
  }
</style>
